class Product {
  constructor(element) {
    this.element = element;
    this.image = this.element.querySelector('.product-image');
    this.video = this.element.querySelector('.collection-grid__video');
    this.imageWrapper = this.element.querySelector('.collection-grid__image-wrapper');
    this.titleLink = this.element.querySelector('.home-page-collection__item-title');
    this.price = this.element.querySelector('.product-price');
    this.compare = this.element.querySelector('.compare-price');
    this.variants = Array.from( this.element.querySelectorAll('.variant-radio') );
    this.variantWrappers = this.element.querySelectorAll('.variant-wrapper');
    this.productTitleLink = this.element.querySelector('.product-title');
    this.defaultImageSrc = this.image?.src || '';
    this.defaultVariantName = '';

    this.soldBadge = this.element.querySelector('.sold-badge');
    this.newBadge = this.element.querySelector('.new-badge');
    this.limitedBadge = this.element.querySelector('.limited-badge');
    this.backBadge = this.element.querySelector('.back-badge');
    this.specialBadge = this.element.querySelector('.special-badge');
    this.bestChoise = this.element.querySelector('.product-best-choise-image');

    if (this.imageWrapper) {
      this.imageWrapper.addEventListener('mouseover', this.handleImageWrapperMouseOver.bind(this));
      this.imageWrapper.addEventListener('mouseout', this.handleImageWrapperMouseOut.bind(this));
    }

    this.addEventListeners();

    if (this.video) this.addVideoEventListeners();

    const selectedVariant = this.variants.find((variant) => variant.checked) || this.variants[0];

    if (selectedVariant) this.updateVariant(selectedVariant);
  }

  handleImageWrapperMouseOver() {
    this.imageWrapper.classList.add('hovered');
  }

  handleImageWrapperMouseOut() {
    this.imageWrapper.classList.remove('hovered');
  }

  addEventListeners() {
    this.variantWrappers.forEach((wrapper, index) => {
      const radio = this.variants[index];
      if (!radio) return;

      wrapper.addEventListener('mouseover', () => this.previewVariant(radio));
      wrapper.addEventListener('mouseout', () => this.resetImageToDefault());
      radio.addEventListener('change', () => this.updateVariant(radio));
    });
  }

  addVideoEventListeners() {
    if (!this.imageWrapper) return;
    this.imageWrapper.addEventListener('mouseover', () => this.playVideo());
    this.imageWrapper.addEventListener('mouseout', () => this.stopVideo());
  }

  playVideo() {
    if (!this.image || !this.video) return;
    this.image.classList.add('hidden-element');
    this.video.classList.remove('hidden-element');
    if (this.video.tagName === 'VIDEO') this.video.play();
  }

  stopVideo() {
    if (!this.image || !this.video) return;
    this.image.classList.remove('hidden-element');
    this.video.classList.add('hidden-element');
    if (this.video.tagName === 'VIDEO') this.video.pause();
  }

  previewVariant(variant) {
    const imgUrl = variant.getAttribute('data-image');
    if (this.image && imgUrl) this.image.src = imgUrl;

    const variantWrapper = variant.closest('.variant-wrapper');
    if (variantWrapper) {
      variantWrapper.classList.add('hovered');
      this.variantWrappers.forEach((w) => {
        if (w !== variantWrapper) w.classList.add('not-hovered');
      });
    }

    const variantNameElement = this.element.querySelector('.item-variant-name');
    if (variantNameElement) {
      if (!this.defaultVariantName) this.defaultVariantName = variantNameElement.textContent || '';
      variantNameElement.textContent = variant.getAttribute('variant-name') || '';
    }

    this.toggleBadges(variant);
  }

  resetImageToDefault() {
    if (this.image && this.defaultImageSrc) this.image.src = this.defaultImageSrc;

    this.variantWrappers.forEach((w) => {
      w.classList.remove('hovered', 'not-hovered');
    });

    const variantNameElement = this.element.querySelector('.item-variant-name');
    if (variantNameElement) {
      variantNameElement.textContent = this.defaultVariantName || '';
    }

    const selectedVariant = Array.from(this.variants).find((v) => v.checked);
    this.toggleBadges(selectedVariant);
  }

  updateVariant(variant) {
    const imgUrl = variant.getAttribute('data-image');
    if (imgUrl) {
      this.defaultImageSrc = imgUrl;
      if (this.image) this.image.src = imgUrl;
    }

    const variantNameElement = this.element.querySelector('.item-variant-name');
    const vname = variant.getAttribute('variant-name') || '';
    if (variantNameElement) {
      variantNameElement.textContent = vname;
      this.defaultVariantName = vname;
    }

    const variantUrl = variant.getAttribute('data-url');
    if (variantUrl) {
      const productTitleLinks = this.element.querySelectorAll('.product-title');
      productTitleLinks.forEach((link) => (link.href = variantUrl));

      const shopNowButton = this.element.querySelector('.home-page-collection__button');
      if (shopNowButton) shopNowButton.href = variantUrl;

      if (this.imageWrapper?.tagName === 'A') {
        this.imageWrapper.href = variantUrl;
      }
      if (this.titleLink) this.titleLink.href = variantUrl;

      const productItemLink = this.element.closest('.home-page-collection__item.product-item');
      if (productItemLink && productItemLink.tagName === 'A') productItemLink.href = variantUrl;
    }

    if (this.video && variant.getAttribute('data-video')) {
      let sources = this.video.getElementsByTagName('source');
      if (sources.length > 0) {
        for (let i = 0; i < sources.length; i++) sources[i].src = variant.getAttribute('data-video');
        this.video.load();
      } else {
        this.video.src = variant.getAttribute('data-video');
      }
    }

    this.toggleBadges(variant);
  }

  toggleBadges(variant) {
    console.log('toggling badges for variant', variant );
    // sold out
    if (this.soldBadge) this.soldBadge.style.display = variant?.hasAttribute('sold-out') ? 'block' : 'none';
    // limited
    if (this.limitedBadge) this.limitedBadge.style.display = variant?.hasAttribute('limited') ? 'block' : 'none';
    // special
    if (this.specialBadge) this.specialBadge.style.display = variant?.hasAttribute('special') ? 'block' : 'none';
    // back in stock
    if (this.backBadge) this.backBadge.style.display = variant?.hasAttribute('back') ? 'block' : 'none';
    // best choice image
    if (this.bestChoise) this.bestChoise.style.display = variant?.hasAttribute('best-choise') ? 'block' : 'none';
    // new
    if (this.newBadge) this.newBadge.style.display = variant?.hasAttribute('new') ? 'block' : 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.home-slider').forEach((sectionEl) => {
    sectionEl.querySelectorAll('.product-item').forEach((product) => new Product(product));
  });
});
